import { MenuItems, MenuGroupType, MenuItemType } from '../navigation'

/**
 * Get active main menu by route
 */
export const getActiveMenu = (props: any) => {
  const { location: { pathname } } = props

  const result = {
    defaultSelectedKeys: [] as Array<string>,
    defaultOpenKeys: [] as Array<string>
  }

  // Remove starting slash
  let currentPath: string = pathname[0] === '/' ? pathname.slice(1, pathname.length) : pathname

  // If our path is empty, then we must be at home :P
  if (currentPath.length === 0) return result

  // Add again starting slash hahahaha
  currentPath = `/${currentPath}`
  // Add ending slash
  currentPath = !currentPath.endsWith('/') ? `${currentPath}/` : currentPath

  MenuItems.forEach((menu: any, menuIndex: number) => {
    if (menu.items) {
      const { items } = menu as MenuGroupType

      items.forEach((subMenu: MenuItemType, subIndex: number) => {
        if (currentPath.includes(`${subMenu.path}/`)) {
          result.defaultOpenKeys.push(`menu-item-${menuIndex}`)
          result.defaultSelectedKeys.push(`menu-item-${menuIndex}-sub-${subIndex}`)
        }
      })
    } else {
      const { path } = menu as MenuItemType

      if (currentPath.includes(`${path}/`)) {
        result.defaultSelectedKeys.push(`menu-item-${menuIndex}`)
      }
    }
  })

  return result
}

/**
 * Get active menu by a dynamic existing menu
 */
export const getDynamicMenuActive = (props: any) => {
  const { location: { pathname } } = props

  const result = {
    defaultSelectedKeys: [] as Array<string>,
    defaultOpenKeys: [] as Array<string>
  }

  // Remove starting slash
  let currentPath: string = pathname[0] === '/' ? pathname.slice(1, pathname.length) : pathname

  // If our path is empty, then we must be at home :P
  if (currentPath.length === 0) return result

  // Add again starting slash hahahaha
  currentPath = `/${currentPath}`
  // Add ending slash
  currentPath = !currentPath.endsWith('/') ? `${currentPath}/` : currentPath

  result.defaultSelectedKeys.push(currentPath)

  return result
}
